import { Device } from "@/api/baseDefine";

export class DeviceUtils {
    private deviceList: Device[] = [];
    private deviceConfig: any = null
    private selectDeviceList: Device[] = [];
    private bindIds: string[] = [];

    public setDeviceConfig(deviceConfig: any) {
        this.deviceConfig = deviceConfig
    }

    public parseResponse(msg: string) {
        let json: any = JSON.parse(msg);
        console.log("parseResponse", json);
        if (json["devices"]) {
            this.deviceList = [];
            let devices: any = json["devices"];
            for (var i = 0; i < devices.length; i++) {
                var d: Device = <Device>{};
                let id: string = devices[i].id;
                let cls: string = devices[i].cls;
                let cls1 = cls.slice(0, 6);
                let cls2 = cls.slice(6, 8);
                d.class = cls;
                d.deviceId = id;
                d.status = "N/A";
                d.inUse = "No";
                d.className = this.deviceConfig["class"][cls1]["en"] + cls2;
                this.deviceList.push(d);
                this.bindIdToDevices();
            }
        } else if (json["properties"]) {
            // this.getProperties(json["properties"]);
        } else if (json["id"]) {
            this.bindIds = json["id"];
            this.bindIdToDevices();
        }
    }

    private bindIdToDevices() {
        this.selectDeviceList = [];
        let mapId: Map<string, boolean> = new Map();
        for (let i = 0; i < this.bindIds.length; i++) {
            mapId.set(this.bindIds[i], true);
        }
        console.log(mapId);
        for (let i = 0; i < this.deviceList.length; i++) {
            if (mapId.get(this.deviceList[i].deviceId)) {
                if (this.deviceList[i].status != "Online") {
                    this.deviceList[i].status = "Online";
                }
                if (this.deviceList[i].inUse != "Yes") {
                    this.deviceList[i].inUse = "Yes";
                }
                this.selectDeviceList.push(this.deviceList[i]);
            } else {
                if (this.deviceList[i].status != "N/A") {
                    this.deviceList[i].status = "N/A";
                }
                if (this.deviceList[i].inUse != "No") {
                    this.deviceList[i].inUse = "No";
                }
            }
        }
        // this.deviceControlUtils.setDeviceList(this.deviceList);
    }

    // private getProperties(properties) {
    //     if (this.sendCmd == "PPTS") {
    //         return this.geEpcFromProperties(properties);
    //     }
    //     for (let i = 0; i < this.selectPropertyList.length; i++) {
    //         if (properties[this.selectPropertyList[i].epc]) {
    //             console.log("111111111111", i, this.propertyList[i].epc);
    //             this.$set(
    //                 this.selectPropertyList[i],
    //                 "updatedAt",
    //                 formatDateTime(new Date())
    //             );
    //             this.$set(
    //                 this.selectPropertyList[i],
    //                 "data",
    //                 properties[this.selectPropertyList[i].epc]
    //             );
    //         }
    //     }
    //     console.log(this.selectPropertyList);
    // }

    public geEpcFromProperties(properties, propertyList: any) {
        console.log("geEpcFromProperties", properties)
        let pList: string[] = [];
        let p_9d = properties["0x9D"];
        let p_9e = properties["0x9E"];
        let p_9f = properties["0x9F"];
        this.getPropertyListFromFormat(pList, p_9d)
        this.getPropertyListFromFormat(pList, p_9e)
        this.getPropertyListFromFormat(pList, p_9f)
        let selectPropertyList: any = [];
        let m: Map<string, boolean> = new Map();
        for (let i = 0; i < pList.length; i++) {
            m.set(pList[i], true);
        }
        for (let i = 0; i < propertyList.length; i++) {
            if (m.get(propertyList[i].epc)) {
                selectPropertyList.push(propertyList[i]);
            }
        }
        return selectPropertyList
    }

    public getPropertyListFromFormat(list: string[], input: string) {
        if (input.length < 4) {
            return
        }
        let dataLength = parseInt(input.slice(0, 4))
        if (dataLength < 16) {
            for (let i = 6; i <= input.length; i += 2) {
                list.push("0x" + input.slice(i - 2, i));
            }
        } else {
            for (let i = 6; i <= input.length; i += 2) {
                let binaryStr = parseInt("0x" + input.slice(i - 2, i)).toString(2)
                let l = 8-binaryStr.length
                for(let z=0;z<l;z++){
                    binaryStr = '0'+binaryStr
                }
                for (let j = 0; j < 8; j++) {
                    if (binaryStr.length > j && binaryStr[j] == "1") {
                        let firstInt = 15 - j;
                        if (firstInt == 10) {
                            firstInt--
                        }
                        let first = firstInt.toString(16)
                        let secondInt = ((i - 4) / 2 - 1)
                        let second = secondInt.toString(16)
                        list.push("0x" + (first + second).toUpperCase())
                        console.log((first + second).toUpperCase())
                    }
                }
            }
        }
        console.log("333333333333", list)
    }

}